import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, ChangeDetectionStrategy } from '@angular/core';
import { NotificationApiService } from '../../generated/api/notification/notification.service';
import { Notification } from '../../generated/api/kreditportalBackendAPI.schemas';

@Component({
    selector: 'elem-hd-messages',
    templateUrl: './hd-messages.component.html',
    styleUrls: ['./hd-messages.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderMessagesComponent implements OnChanges, OnDestroy {

    @Input()
    menuShown: boolean;

    @Output()
    notifyOpened: EventEmitter<number> = new EventEmitter();

    tableWidth = '120px';

    notifications: Notification[] = [];

    constructor(private readonly notificationApiService: NotificationApiService) {
        notificationApiService.getNotifications().subscribe(notifications => {
            this.notifications = notifications.messages;
        });
    }

    ngOnChanges() {
        const parent: HTMLElement = document.getElementById('headerNotifications');
        this.tableWidth = (parent.offsetWidth) + 'px';
    }

    ngOnDestroy() {
        this.notifications = [];
    }

    getDisplayedStyle(): string {
        return this.menuShown ? 'block' : 'none';
    }

    getWidth(): string {
        return this.tableWidth;
    }

    getBgColorStyle(): string {
        return this.menuShown ? 'white' : 'transparent';
    }

    click(): void {
        this.menuShown = !this.menuShown;
        if (this.menuShown) {
            this.notifyOpened.emit(1);
        }
    }

}
